import { getPaymentTransactionDetailsApi, getPaymentTransactionListApi } from "_services/accountingServices/accountingServices";
import { CustomPagination } from "components";
import Tab from "components/common/Tab";
import { constant, genExpensedata } from 'constants/constant';
import { useContext, useEffect, useRef, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import StorageService from "utils/StorageServices";
import { GenExpense } from "./GenExpenseFormat";
import { utils } from "helper";
import { UserContext } from "context";
import { MakePaymentForExpense, MakePaymentOfServiceModal, PaymentConfirmModal, PaymentProcessingOffcanvas, PaymentStatusCard, PaymentSuccessOffcanvas } from "modals";
import printHtmlContent from "helper/utils";

const toFixed2 = (val) => (Number(val) || 0).toFixed(2);  // ✅ safe toFixed helper

const TransactionExpDetails = () => {
  const { id } = useParams();
  const [query] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { masterData } = useContext(UserContext);

  const qOffset = +query.get('offset') || 0;
  const qTotalRecord = +query.get('total_record') || 0;
  const itemsPerPage = 10;

  const [activeTab, setActiveTab] = useState(1);
  const [list, setList] = useState([]);
  const [totalRecord, setTotalRecord] = useState(qTotalRecord);
  const [currentPage, setCurrentPage] = useState(Math.floor(qOffset / itemsPerPage) + 1); // ✅ proper page state
  const [details, setDetails] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(null); // ✅ null instead of {}
  const [isOpenPayment, setIsOpenPayment] = useState(false)
  const [isOpenPayNow, setIsOpenPayNow] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [paymentData, setPaymentData] = useState({
    voucher_id: "",
    data: {}
  })
  const [isMakeStatusOpen, setIsMakeStatusOpen] = useState(false);
  const [canvasKey, setCanvasKey] = useState(0);


  const [eaesbuzzId, setEaesbuzzId] = useState({
    eb_account_id: "",
    total_amount: 0
  })


 const isPaymentAllowed =
  customerDetails && activeTab === 2 && customerDetails.status !== "Completed";

  const tabProps = {
    tabList: constant.transactionExpensesTabs,
    callBackTab: setActiveTab,
    activeTab,
    isActiveButton:isPaymentAllowed,
    tabButtonName: 'Record Payment',
    rightButton: () => setIsOpenPayment(true)
  };

  // ── Fetch list ────────────────────────────────────────────────────────────
  const fetchList = async (offset = qOffset) => {
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        limit: itemsPerPage,
        offset,
      };
      const res = await getPaymentTransactionListApi(payload);
      if (res?.responseCode === 200) {
        const items = res?.data?.list || [];
        const found = items.find((el) => el?._id === id);
        setList(items);
        setTotalRecord(res?.data?.total_record);
        setDetails(found || items[0] || null);

        const params = new URLSearchParams(location.search);
        params.set('offset', offset);
        params.set('total_record', res?.data?.total_record);
        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ── Fetch details ─────────────────────────────────────────────────────────
  const fetchDetails = async () => {
    try {
      if (!id) return; // ✅ guard
      const res = await getPaymentTransactionDetailsApi({ expense_id: id });
      if (res?.responseCode === 200) {
        setCustomerDetails(res?.data?.expense);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ── List item click ───────────────────────────────────────────────────────
  const handleItemClick = (item) => {
    setDetails(item);
    setCustomerDetails(null); // ✅ reset details on item change
    const params = new URLSearchParams(location.search);
    navigate(`/accounting/transactionExpDetails/${item._id}?${params.toString()}`);
  };

  // ── Pagination ────────────────────────────────────────────────────────────
  const handlePageChange = (page) => {
    setCurrentPage(page); // ✅ update page state
    fetchList((page - 1) * itemsPerPage);
  };


  const callbackEaesbuzz = (id, amount, venderDetails, payload) => {

    setEaesbuzzId((pre) => ({
      ...pre, eb_account_id: id,
      total_amount: amount,
      vendor_bank_account: venderDetails?.vendor_bank_account,
      payload: payload
    }))
  }

  useEffect(() => { fetchList(); }, []);

  useEffect(() => {
    if (id && activeTab === 2) { // ✅ strict equality
      fetchDetails();
    }
  }, [id, activeTab]);

  const transactions = customerDetails?.transactions || [];

  const onShareReceipt = () => {

  }

  const viewReceiptHandle = (data) => {
    setIsSuccessOpen(data)
  }

  const doneHandle = () => {
    fetchDetails()
    setIsOpenPayment(false)
    setIsOpenPayNow(false)
    setIsMakeStatusOpen(false)
  }

  const paymentResult = (data, voucher_id) => {
    fetchDetails()
    setIsOpenPayment(false)
    setIsProcessing(false);
    setIsOpenPayNow(false)
    setIsMakeStatusOpen(true);
    setPaymentData({
      voucher_id: voucher_id,
      data: data
    })
    setCanvasKey(prev => prev + 1);
  }

  const handleDownloadReceipt = async () => {
    try {
      const response = await fetch(`/api/receipt/${paymentData?.transactionId}`);
      const blob = await response.blob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `receipt_${paymentData?.transactionId}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      alert('Failed to download receipt');
    }
  };

  const makePaymentProps = {
    isOpen: isOpenPayment,
    closeModal: () => setIsOpenPayment(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _lgModal",
    modalTitle: "Add Payment",
    submitTitle: "Add Payment",
    details: details,
    customerDetails:customerDetails,
    callbackEaesbuzz: callbackEaesbuzz,
    setIsOpenPayNow,
    callBackFreight: fetchDetails

  }

  let payNowProps = {
    isOpen: isOpenPayNow,
    closeModal: (e) => setIsOpenPayNow(false),
    setIsProcessing, setIsProcessing,
    setIsOpenPayNow: setIsOpenPayNow,
    easebuzzDetails: eaesbuzzId
  }

  const getStatusStyle = (status) => {
    const map = {
      Completed: { label: "Completed", color: "#22C55E" },
      Cancelled: { label: "Cancelled", color: "#EF4444" },
      Pending: { label: "Pending", color: "#F97316" },
    };
    return map[status] || { label: status || "-", color: "#6B7280" };
  };

  return (
    <div className='trs-listDetail'>

      {/* ── Left: List Panel ── */}
      <div className='trs-listBx_ns'>
        <div className='trs-dropDown-head'>
          <div className="dropdown">
            <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              General Expenses
            </button>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item px-2">EMI</a></li>
              <li><a className="dropdown-item px-2">Servicing</a></li>
              <li><a className="dropdown-item px-2">Documents</a></li>
            </ul>
          </div>
        </div>

        <div className='trs-listBx_ns_content'>
          <div className='trs-listBx_ns_content_list'>
            {list.map((item) => (
              <div
                key={item._id}
                className={`trs-line${item._id === (details?._id || id) ? ' active' : ''}`}
                onClick={() => handleItemClick(item)}
              >
                <div className='trs-listBx-heading'>
                  <p>{item?.vendor_detail?.name || item?.firm?.firm || 'Name not available'}</p>
                  <span>{item?.invoice_number} | {item?.date ? new Date(item.date).toLocaleDateString('en-IN') : '-'}</span>
                  <div className='trs-status' style={{ background: getStatusStyle(item?.status).color }}>{getStatusStyle(item?.status).label || 'Unpaid'}</div>
                </div>
              </div>
            ))}
          </div>

          {list.length > 0 && (
            <div className='paginationFt_avt'>
              <CustomPagination
                totalItems={totalRecord}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}        // ✅ using state value
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>

      {/* ── Right: Detail Panel ── */}
      <div className='trs-detailBx'>
        <div className='trs-detailBx_head'>
          <div className='trs-left-head'>
            <p>{details?.invoice_number || 'Select an item'}</p>
            <div className='trs-status' style={{ background: getStatusStyle(details?.status).color }}>{getStatusStyle(details?.status).label || '-'}</div>
          </div>
          <div className='trs-right-head'>
            <button className='trs-dwn-btn anime-btn'>Download PDF</button>
            <button className='trs-dwn-btn anime-btn'>Print Voucher</button>
            <button className='trs-cancel-btn' onClick={() => navigate("/accounting/ptransactions")}><RxCross2 /></button>
          </div>
        </div>

        <div className='trs-inp-tabBxs'>
          <div className="addPr_flBx __uiTx_new">
            <Tab {...tabProps} />
            <div className='trs-inp-tabContent'>

              {/* Tab 1: Invoice Preview */}
              {activeTab === 1 && <GenExpense data={genExpensedata} />}

              {/* Tab 2: Payment History */}
              {activeTab === 2 && (
                <div className="trs-payment-history-card">
                  <div className="trs-ph-header">
                    <h3>Payment History</h3>
                    <div className="trs-ph-row">
                      <span className="trs-ph-label">Invoice Amount</span>
                      <span className="trs-ph-amount">₹ {toFixed2(customerDetails?.total_amount)}</span>
                    </div>
                  </div>

                  <div className="trs-ph-payment-box">
                    {transactions.length > 0
                      ? transactions.map((t, i) => (
                        <div key={t?._id || i}>
                          <div className="trs-ph-payment-row">
                            <div>
                              <div className="trs-ph-payment-title">
                                Payment
                                {/* ✅ only show badge if approval_status is not 0 and exists */}
                                {t?.approval_status != null && t?.approval_status !== 0 && (
                                  <span className="trs-ph-badge">
                                    {masterData?.payment_approval_status?.[t?.approval_status]}
                                  </span>
                                )}
                              </div>
                              <div className="trs-ph-payment-meta">
                                {t?.date ? utils.formatDateMonth(t.date) : '-'} | {t?.voucher_no || '-'} | {t?.payment_mode?.account?.name || '-'}
                              </div>
                            </div>
                            <div className="trs-ph-payment-amount">
                              ₹ {toFixed2(t?.total_amount)}
                            </div>
                          </div>
                          {/* ✅ divider between items, not after last */}
                          {i < transactions.length - 1 && <div className="trs-ph-divider" />}
                        </div>
                      ))
                      : <p className="trs-ph-empty">No payment history found.</p> // ✅ empty state
                    }
                  </div>

                  <div className="trs-ph-footer">
                    <div className="trs-ph-row">
                      <span className="trs-ph-label">Invoice Amount Received</span>
                      <span className="trs-ph-amount">₹ {toFixed2(customerDetails?.paid_amount)}</span>
                    </div>
                    <div className="trs-ph-row">
                      <span className="trs-ph-label trs-ph-danger">Balance Due</span>
                      <span className="trs-ph-amount trs-ph-danger">₹ {toFixed2(customerDetails?.due_amount)}</span>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
      {isOpenPayment && <MakePaymentForExpense {...makePaymentProps} />}

      {isOpenPayNow && <PaymentConfirmModal {...payNowProps} />}
      {isProcessing && <PaymentProcessingOffcanvas
        isOpen={isProcessing}
        message="Please wait while we process your transaction..."
        paymentResult={paymentResult}
        eaesbuzzId={eaesbuzzId}
        onClose={() => {
          setIsProcessing(false)
          setIsOpenPayNow(false)
          setIsOpenPayment(false);
        }}
      />}

      {isMakeStatusOpen && <PaymentStatusCard isOpen={isMakeStatusOpen}
        onClose={() => setIsMakeStatusOpen(false)}
        paymentData={paymentData}
        details={{ _id: paymentData?.data?.voucher_id }}
        onShareReceipt={onShareReceipt}
        viewReceiptHandle={viewReceiptHandle}
        doneHandle={doneHandle}
      />}

      {/* <div className={isProcessing ? "offBack_drop" : ""}></div> */}
      {isSuccessOpen && <PaymentSuccessOffcanvas
        isOpen={isSuccessOpen}
        onClose={() => setIsSuccessOpen(false)}
        paymentData={paymentData}
        onDownloadReceipt={handleDownloadReceipt}
        onContactUs={() => alert('Contact support')}
      />}
      <div className={isSuccessOpen ? "offBack_drop" : ""}></div>
    </div>
  );
};

export default TransactionExpDetails;